import React, { FC } from 'react'
import styled from 'styled-components'

import { Tooltip } from '../tooltip'
import { Color } from './Color'

export type Props = {
  colors: Array<ColorDeclaration>
  value: Array<string>
  onChange: (value: Array<string>) => any
}

export type ColorDeclaration = {
  value: string
  colorName?: string
  color: string
  sectionId: string
}

export const ColorSelect: FC<Props> = ({ colors = [], value = [], onChange }) => {
  const toggleColor = (colorValue: string) => {
    if (value.includes(colorValue)) {
      onChange(value.filter((item) => item !== colorValue))
    } else {
      onChange([...value, colorValue])
    }
  }

  const renderColor = (color: ColorDeclaration) => (
    <Color
      data-tip
      data-for={color.value}
      data-color-name={color.colorName}
      data-name={color.sectionId}
      color={color.color}
      onClick={() => toggleColor(color.value)}
      active={value.includes(color.value)}
    />
  )

  return (
    <Wrapper className={'color-picker'}>
      {colors.map((color) => (
        <ColorWrapper key={color.value}>
          {color.colorName ? (
            <>
              {renderColor(color)}
              <Tooltip id={color.value}>{color.colorName}</Tooltip>
            </>
          ) : (
            renderColor(color)
          )}
        </ColorWrapper>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => `repeat(auto-fill, ${theme.spacing[6]})`};
  grid-template-rows: ${({ theme }) => `repeat(auto-fill, ${theme.spacing[6]})`};
  gap: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[3]}`};
`

const ColorWrapper = styled.div`
  /* margin-bottom: 1.3rem;
  &:not(:last-child) {
    margin-right: 1.3rem;
  } */
`
